import {useState} from "react";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {TABLES} from "../../../../Apis/Tables";

/**
 * List of the zones step, paged and searched by name. On the creation it lists the available zones;
 * on the update it is shared by the add and the assigned tabs, as the devices do, so only the tab
 * shown reads it.
 */
const ZoneStepApp = () => {
    const [zoneResults, setZoneResults] = useState(null);
    const [zoneSearchElement, setZoneSearchElement] = useState('');
    const [zoneModified, setZoneModified] = useState(false);
    const [, setZoneSearch] = useState(false);
    const [, setZoneSimpleSearch] = useState(false);
    const [, setZoneBodyForExport] = useState(null);

    /**
     * Request of a page of the available zones, searched by name.
     */
    const zoneTableBuildBody = ({page, rowsPerPage, searchElement}) => ({
        body: SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: TABLES.ZONE_ACCESS_AVAILABLE_ZONE,
            key: searchElement,
        }),
    });

    return {
        zoneResults,
        setZoneResults,
        zoneSearchElement,
        setZoneSearchElement,
        setZoneSearch,
        setZoneSimpleSearch,
        setZoneBodyForExport,
        zoneModified,
        setZoneModified,
        zoneTableBuildBody,
    };
};

export default ZoneStepApp;
